import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

export const defaultState = {
  settlements: [],
  settlementHistory: [],
};

export const mutations = {
  SET_STRATEGIES_SETTLEMENT_DATA(settlementState, data) {
    settlementState.settlements = data;
  },
  SET_STRATEGIES_SETTLEMENT_HISTORY_DATA(settlementState, data) {
    settlementState.settlementHistory = data;
  },
};

export const getters = {
  getSettlements: contractState => contractState.settlements,
  getSettlementsHistory: contractState => contractState.settlementHistory,
};

export const actions = {

  fetchStrategiesSettlements({ commit }, params) {
    return axios.get(`${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement?key=${params ? params.key : ''}&value=${params ? params.value : ''}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          commit('SET_STRATEGIES_SETTLEMENT_DATA', response.data);

          return response.data;
        });
      })
      .catch((error) => {
        commit('SET_STRATEGIES_SETTLEMENT_DATA', []);

        return Promise.reject(error);
      });
  },

  // eslint-disable-next-line no-unused-vars
  fetchStrategiesSettlementsDownloadCsv({ commit }, params) {
    // eslint-disable-next-line max-len
    return axios.get(`${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/export/csv?key=${params ? params.key : ''}&value=${params ? params.value : ''}&type=${params ? params.type : ''}`)
      .then(({ data, headers }) => ({
        data,
        headers,
      }))
      .catch(error => Promise.reject(error));
  },

  fetchStrategiesSettlementHistory({ commit }, settlementId) {
    return axios.get(`${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/${settlementId}`)
      .then(({ data }) => {
        commit('SET_STRATEGIES_SETTLEMENT_HISTORY_DATA', data.data);

        return data.data;
      })
      .catch((error) => {
        commit('SET_STRATEGIES_SETTLEMENT_HISTORY_DATA', []);

        return Promise.reject(error);
      });
  },

  // eslint-disable-next-line no-unused-vars
  settlementPushLatestState({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.STRATEGIES_SETTLEMENT}/settlement/replay-latest-state`, payload)
      .then(data => data).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
};

const strategiesSettlement = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default strategiesSettlement;



// WEBPACK FOOTER //
// ./src/store/settlements/strategiesSettlement.js